module.exports = __webpack_public_path__ + "img/code_2014.e966380f.png";